<app-patient-info [heading]="Item"></app-patient-info>
<p-tabView [(activeIndex)]="activeIndex">
    <p-tabPanel header="Summary">
        <p-table #dt
                 *ngIf="finansummary"
                 [responsive]="true"
                 [columns]="selectedColumns"
                 [value]="finansummary.data"
                 selectionMode="single"
                 dataKey="encounterno"
                 [resetPageOnSort]="false"
                 [lazy]="false"
                 [rows]="rows"
                 [paginator]="showRecordsFinancialSummary"
                 (sortFunction)="customSort($event, 1)"
                 [customSort]="true">
            <ng-template pTemplate="caption">
                <p-multiSelect [options]="cols"
                               [(ngModel)]="selectedColumns"
                               optionLabel="header"
                               selectedItemsLabel="{0} columns selected"
                               [style]="{ 'min-width': '200px' }"
                               placeholder="Choose Columns" />
            </ng-template>

            <ng-template pTemplate="header" let-columns>
                <tr *ngIf="showRecordsFinancialSummary == true">
                    <th></th>
                    <th *ngFor="let col of columns"
                        [hidden]="col.hidden"
                        [pSortableColumn]="col.sort === 1 ? col.field : ''">
                        {{ col.header }}
                        <p-sortIcon *ngIf="col.sort === 1"
                                    [field]="col.field"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                </tr>
                <tr class="bold" style="background: #d9d9d9; height: 30px">
                    <td [attr.colspan]="calculateColSpan()">
                        <span style="float: right">Total: &nbsp;&nbsp;&nbsp;</span>
                    </td>
                    <td *ngIf="shouldtotalBeVisible('charge')">
                        {{ calculateGroupTotal('tc') }}
                    </td>
                    <td *ngIf="shouldtotalBeVisible('paid')">
                        {{ calculateGroupTotal('tp') }}
                    </td>
                    <td *ngIf="shouldtotalBeVisible('adjustement')">
                        {{ calculateGroupTotal('ta') }}
                    </td>
                    <td *ngIf="shouldtotalBeVisible('coB1')">
                        {{ calculateGroupTotal('tcob1') }}
                    </td>
                    <td *ngIf="shouldtotalBeVisible('coB2')">
                        {{ calculateGroupTotal('tcob2') }}
                    </td>
                    <td *ngIf="shouldtotalBeVisible('coB3')">
                        {{ calculateGroupTotal('tcob3') }}
                    </td>
                    <td *ngIf="shouldtotalBeVisible('pat')">
                        {{ calculateGroupTotal('tpat') }}
                    </td>
                    <td *ngIf="shouldtotalBeVisible('badDebit')">
                        {{ calculateGroupTotal('tbad') }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-rowData
                         let-columns="columns"
                         let-i="rowIndex">
                <tr [pSelectableRow]="rowData">
                    <td>
                        <button pButton
                                type="button"
                                icon="pi pi-user"
                                class="p-button-info"
                                style="font-size: 0.7em"
                                (click)="
                getfinancialDetails(
                  rowData['enCounterNo'],
                  rowData['billableDate'],
                  rowData['renderingProvider']
                )
              "></button>
                    </td>

                    <td *ngFor="let col of columns">
                        <!--<span class="column-title">{{col.header}}</span>-->
                        {{ rowData[col.field] }}
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage"> </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                Showing {{ state.page * state.rows + 1 }} to
                {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
            </ng-template>
        </p-table>

        <!-- NOTE: If internal empty message didn't render' -->
        <div id="emptymessage"
             class="w-12 pt-4"
             *ngIf="!(finansummary?.data.length > 0)">
            <div class="mb-4" style="text-align: center">
                <img _ngcontent-ng-c683320295=""
                     class="profile-image"
                     style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                     src="assets/imagesNew/table_error.png" />
            </div>
            <hr style="margin-bottom: 0.5rem" />
            <div class=""
                 style="text-align: center; font-size: larger; color: #1d428f">
                <i>No records found</i>
            </div>
        </div>
    </p-tabPanel>

    <p-tabPanel header="Archive Transactions" *ngIf="isArchiveInstance">
        <div class="pb-2"
             style="display: flex; justify-content: space-between; align-items: center">
            <div></div>
            <div>
                <button pButton
                        type="button"
                        pTooltipPosition="true"
                        icon="pi pi-link"
                        style="font-size: 1.2em"
                        label="Post Transaction"
                        class="ui-button-secondary"
                        (click)="addTransation_click()"></button>
            </div>
        </div>
        <p-table #dt
                 *ngIf="listTransaction"
                 [responsive]="true"
                 [columns]="colsTrans"
                 [value]="listTransaction.data"
                 selectionMode="single"
                 dataKey="transactionId"
                 [resetPageOnSort]="false"
                 [lazy]="false"
                 [rows]="rows"
                 [paginator]="showRecordsArchiveTransaction"
                 (sortFunction)="customSort($event, 1)"
                 [customSort]="true">
            <ng-template pTemplate="header" let-columns>
                <tr *ngIf="showRecordsArchiveTransaction == true">
                    <th *ngFor="let col of columns">
                        {{ col.header }}
                    </th>
                    <th>Edit</th>
                    <th>Delete</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-rowData
                         let-columns="columns"
                         let-i="rowIndex">
                <tr [pSelectableRow]="rowData">
                    <td *ngFor="let col of columns">
                        {{ rowData[col.field] }}
                    </td>
                    <td>
                        <button pButton
                                type="button"
                                icon="pi pi-pencil"
                                class="p-button-plain"
                                style="font-size: 0.7em"
                                (click)="onEditTransation($event, rowData['transactionId'])"></button>
                    </td>
                    <td>
                        <button pButton
                                type="button"
                                icon="pi pi-trash"
                                class="p-button-danger"
                                style="font-size: 0.7em"
                                (click)="onDeleteTransation($event, rowData['transactionId'])"></button>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage"> </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                Showing {{ state.page * state.rows + 1 }} to
                {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
            </ng-template>
        </p-table>

        <!-- NOTE: If internal empty message didn't render' -->
        <div id="emptymessage"
             class="w-12 pt-4"
             *ngIf="!(listTransaction?.data.length > 0)">
            <div class="mb-4" style="text-align: center">
                <img _ngcontent-ng-c683320295=""
                     class="profile-image"
                     style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                     src="assets/imagesNew/table_error.png" />
            </div>
            <hr style="margin-bottom: 0.5rem" />
            <div class=""
                 style="text-align: center; font-size: larger; color: #1d428f">
                <i>No Archive Transactions for Patient.</i>
            </div>
        </div>
    </p-tabPanel>
</p-tabView>

<p-dialog [(visible)]="displaypopupTransactions_AddEdit"
          [draggable]="true"
          [modal]="true"
          positionType="absolute"
          [style]="{ width: '50vw' }"
          [baseZIndex]="10000"
          [maximizable]="true">
    <p-header>
        {{ popupheader }}
    </p-header>
    <div class="grid">
        <div class="col-12 p-md12">
            <form [formGroup]="transactionsForm" (ngSubmit)="saveTransaction()">
                <div class="p-fluid formgrid grid">
                    <div class="field col-12 md:col-6">
                        <p-dropdown [options]="transactionTypes"
                                    appFormErrorMessages
                                    optionLabel="text"
                                    optionValue="value"
                                    placeholder="Select Transaction Type"
                                    class="p-fluid"
                                    formControlName="transactionType"
                                    appendTo="body"></p-dropdown>
                    </div>

                    <div class="field col-12 md:col-6">
                        <p-dropdown [options]="transactionSources"
                                    appFormErrorMessages
                                    optionLabel="text"
                                    optionValue="value"
                                    placeholder="Select Transaction Source"
                                    class="p-fluid"
                                    formControlName="transactionSource"
                                    appendTo="body"></p-dropdown>
                    </div>
                </div>
                <div class="p-fluid formgrid grid">
                    <div class="field col-12 md:col-6">
                        <span class="p-float-label">
                            <!--<input id="transactionDate" type="text" appFormErrorMessages pInputText formControlName="transactionDate">-->

                            <p-calendar id="transactionDate"
                                        formControlName="transactionDate"
                                        [yearNavigator]="true"
                                        [readonlyInput]="true"
                                        showButtonBar="true"
                                        appendTo="body"></p-calendar>
                            <label for="float-input"> Date of Transaction</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-6">
                        <span class="p-float-label">
                            <input id="encounterNo"
                                   type="text"
                                   appFormErrorMessages
                                   pInputText
                                   formControlName="encounterNo" />
                            <label for="float-input"> Encounter #</label>
                        </span>
                    </div>
                </div>
                <div class="p-fluid formgrid grid">
                    <div class="field col-12 md:col-6">
                        <span class="p-float-label">
                            <input id="transactionAmount"
                                   type="text"
                                   appFormErrorMessages
                                   pInputText
                                   formControlName="transactionAmount" />
                            <label for="float-input">Transaction Amount $</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-6">
                        <span class="p-float-label">
                            <input id="notes"
                                   type="text"
                                   appFormErrorMessages
                                   pInputText
                                   formControlName="notes" />
                            <label for="float-input"> Notes</label>
                        </span>
                    </div>
                </div>
                <button pButton
                        type="submit"
                        label="Save"
                        icon="pi pi-check"
                        style="margin-right: 0.25em"></button>
                <button pButton
                        type="button"
                        icon="pi pi-Error"
                        (click)="displaypopupTransactions_AddEdit = false"
                        label="Cancel"
                        class="ui-button-secondary GreyButton"></button>
            </form>
        </div>
    </div>

    <!--<p-footer style="display: flex; justify-content:center">
          <button pButton type="button" icon="pi pi-Error" (click)="displaypopupTransactions_AddEdit=false" label="Cancel" class="ui-button-secondary"></button>
      </p-footer>-->
</p-dialog>
